import * as Types from '../../../../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectCreatedSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectCreatedSubscriptionQuery = { __typename: 'Subscription', projectCreated: { __typename: 'ProjectCreatedPayload', id: string } };


export const ProjectCreatedSubscriptionQueryDocument = gql`
    subscription projectCreatedSubscriptionQuery {
  projectCreated {
    id
  }
}
    `;

/**
 * __useProjectCreatedSubscriptionQuery__
 *
 * To run a query within a React component, call `useProjectCreatedSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCreatedSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCreatedSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectCreatedSubscriptionQuery(baseOptions?: Apollo.SubscriptionHookOptions<ProjectCreatedSubscriptionQuery, ProjectCreatedSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectCreatedSubscriptionQuery, ProjectCreatedSubscriptionQueryVariables>(ProjectCreatedSubscriptionQueryDocument, options);
      }
export type ProjectCreatedSubscriptionQueryHookResult = ReturnType<typeof useProjectCreatedSubscriptionQuery>;